module.exports = __webpack_public_path__ + "electron.90b34c.svg";